/**
 * @generated SignedSource<<a6ea7e1f600ade76ff86e0960902f2cd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type deleteOwnAccountInput = {
  clientMutationId?: string | null;
  password: string;
};
export type DeleteOwnAccountMutation$variables = {
  input: deleteOwnAccountInput;
};
export type DeleteOwnAccountMutation$data = {
  readonly deleteOwnAccount: {
    readonly errors: ReadonlyArray<{
      readonly __typename: "AuthError";
      readonly message?: string;
    }>;
    readonly success: boolean | null;
  } | null;
};
export type DeleteOwnAccountMutation = {
  response: DeleteOwnAccountMutation$data;
  variables: DeleteOwnAccountMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "deleteOwnAccountPayload",
    "kind": "LinkedField",
    "name": "deleteOwnAccount",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AuthError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
              }
            ],
            "type": "UserError",
            "abstractKey": "__isUserError"
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteOwnAccountMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteOwnAccountMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e83e6b65c2b6c3dada8456987c2b27dd",
    "id": null,
    "metadata": {},
    "name": "DeleteOwnAccountMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteOwnAccountMutation(\n  $input: deleteOwnAccountInput!\n) {\n  deleteOwnAccount(input: $input) {\n    success\n    errors {\n      __typename\n      ... on UserError {\n        __isUserError: __typename\n        message\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7474edf16b648110ee18296cd76c2b1e";

export default node;
